/*
 * @Author: Teemo Ding
 * @Date: 2021-05-26 16:35:59
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-29 13:16:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/slice/index.ts
 */
import { unique } from '@/src/tools/helper';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { createSlice } from '@reduxjs/toolkit';

const defaultState = {
  search: '',
  searchList: [],
  sort: {
    name: getI18nFromGeneral('general.hOCTitle.creatednewest'),
    key: 8,
    data: 'CreatedDateDesc',
  },
  loading: true,
};
//TODO:Filter单选和多选的问题
const salesChannelCollectionListSlice = createSlice({
  name: 'salesChannelCollectionList',
  initialState: defaultState,
  reducers: {
    searchChange: (state, action) => {
      state.searchList.push(action.payload);
      state.searchList = unique(state.searchList); //去重
    },
    deleteSearch: (state, action) => {
      state.searchList.splice(action.payload, 1);
    },
    sortBy: (state, action) => {
      state.sort = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { sortBy, searchChange, deleteSearch } =
  salesChannelCollectionListSlice.actions;

export default salesChannelCollectionListSlice.reducer;
